import { htmlSafe } from '@ember/template';
import Modal from 'tio-ui/components/modal';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import type { TOC } from '@ember/component/template-only';
import ErrorMessages from 'tio-ui/components/error-messages';

export interface TuitionAssistanceLimitsSummaryErrorAlertSignature {
  Args: {
    showError: boolean;
    errorMessage: string;
    explanation: string;
  };
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}

const TuitionAssistanceLimitsSummaryErrorAlertComponent: TOC<TuitionAssistanceLimitsSummaryErrorAlertSignature> =
  <template>
    {{#if @showError}}
      {{#let (tracked false) as |isShowingDetails|}}
        <div class="tio-col-flush" ...attributes>
          <ErrorMessages @showErrors={{@showError}} @error={{@errorMessage}} />
          <button
            type="button"
            class="app-text-link app-text-link--inline"
            {{on "click" (fn isShowingDetails.set true)}}
          >
            {{t "tuition_assistance.limits_summary.explain_limit"}}
          </button>
        </div>
        <Modal
          @isOpen={{isShowingDetails.value}}
          @onClose={{fn isShowingDetails.set false}}
          @ariaLabel={{t "common.aria_labels.limit_explanation"}}
        >
          <:body>
            <div class="app-rich-text">{{htmlSafe @explanation}}</div>
          </:body>
        </Modal>
      {{/let}}
    {{/if}}
  </template>;

export default TuitionAssistanceLimitsSummaryErrorAlertComponent;
